module.exports = __webpack_public_path__ + "static/media/joinfree-th.a8f35d36.jpg";